module.exports = __webpack_public_path__ + "static/media/David Barei.c06be337.png";